import { PermissionFullRow } from "namirasoft-access";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { IBaseComponentProps } from "namirasoft-site-react";
import { Component } from "react";
import { AccessProps } from "../AccessProps";
import PolicyTable from "./PolicyTable";
import RoleTable from "./RoleTable";

export interface PermissionPoliciesRolesTablesProps extends IBaseComponentProps, NSARouterMakerResult, AccessProps
{
	id: string;
	get: (id: string) => Promise<PermissionFullRow>;
}

interface PermissionPoliciesRolesTablesState
{
	row: PermissionFullRow | null;
}

export default class PermissionPoliciesRolesTables extends Component<PermissionPoliciesRolesTablesProps, PermissionPoliciesRolesTablesState>
{
	constructor(props: PermissionPoliciesRolesTablesProps)
	{
		super(props);
		this.state = { row: null };
	}

	override async componentDidMount()
	{
		await this.load();
	}

	override async componentDidUpdate(prev: PermissionPoliciesRolesTablesProps)
	{
		if (prev.id !== this.props.id)
			await this.load();
	}

	private async load()
	{
		if (!this.props.id)
		{
			this.setState({ row: null });
			return;
		}
		try
		{
			let row = await this.props.get(this.props.id);
			this.setState({ row });
		}
		catch (e: any)
		{
			this.props.notifier.onError(e);
		}
	}

	override render()
	{
		let row = this.state.row;
		if (!row)
			return <></>;
		let roles = row.roles.filter((r): r is string => r !== null);
		let policies = row.policies.filter((p): p is string => p !== null);
		return <>
			{
				roles.length > 0 &&
				<RoleTable
					{...this.props}
					id={this.props.id}
					ids={roles}
				/>
			}
			{
				policies.length > 0 &&
				<PolicyTable
					{...this.props}
					id={this.props.id}
					ids={policies}
				/>
			}
		</>;
	}
}